import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import AIEmailComposer from '../components/AIEmailComposer'

const EmailComposerPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="AI Email Composer"
        subtitle="Generate personalized emails with AI"
      />
      
      <div className="page-content">
        <AIEmailComposer />
      </div>
    </AppContainer>
  )
}

export default EmailComposerPage